import { connect } from 'react-redux'
import { redirect } from 'redux-first-router'
import { selectPrefersClassicView } from 'ducks/currentUser/selectors/preferences/selectPrefersClassicView'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import {
  selectIsCreatingNewEmail,
  selectIsLoggingNewConversation,
} from 'selectors/page'
import { selectIsMerging } from 'selectors/page/selectIsMerging'
import { isBoostrappedSelector } from 'selectors/app/base'
import { selectRealMailboxes } from 'selectors/mailboxes/selectRealMailboxes'
import {
  selectCurrentTicketSearchQueryString,
  selectHasCurrentTicketSearchErrored,
  selectIsCurrentTicketSearchQueryValid,
} from 'selectors/search'
import { selectIsUpdateAvailable } from 'selectors/app'
import {
  selectIsTicketSelectionMode,
  selectTicketSelectionCount,
} from 'selectors/ticket_list'
import { doOpenSearchPageWithMailboxAndFolder } from 'ducks/channels/actions'

import View from './view'

const select = state => {
  return {
    ticketId: selectCurrentTicketId(state),
    prefersClassicView: selectPrefersClassicView(state),
    isNewEmail: selectIsCreatingNewEmail(state),
    isNewConversation: selectIsLoggingNewConversation(state),
    isBootstrapped: isBoostrappedSelector(state),
    realMailboxes: selectRealMailboxes(state),
    areTicketsSelected: selectTicketSelectionCount(state) > 0,
    hasSearchErrored: selectHasCurrentTicketSearchErrored(state),
    isBulkSelectionMode: selectIsTicketSelectionMode(state),
    isQueryStringValid: selectIsCurrentTicketSearchQueryValid(state),
    isUpdateAvailable: selectIsUpdateAvailable(state),
    isMerging: selectIsMerging(state),
    queryString: selectCurrentTicketSearchQueryString(state),
  }
}

const perform = dispatch => {
  return {
    redirectToSearchPageWithMailboxAndFolder: (...args) =>
      dispatch(redirect(doOpenSearchPageWithMailboxAndFolder(...args))),
  }
}

export default connect(select, perform)(View)
